import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminPanel from './AdminPanel';
import reportWebVitals from './reportWebVitals';

// Simple routing based on URL path
const path = window.location.pathname;

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if we're on the admin panel route
if (path === '/adminpanel' || path === '/adminpanel/') {
  root.render(
    <React.StrictMode>
      <AdminPanel />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
